export default __webpack_public_path__ + "static/media/team_1_compressed.0e5bb2d5.jpg";